import React from "react";

const Footer = () => {
  return (
    <div className="fixed bottom-0 w-full flex justify-center items-center h-16 font-semibold bg-[#eef4f8] text-[#566680]">
      <h1>Copyright © 2025 RCAATS All rights reserved</h1>
    </div>
  );
};

export default Footer;
